import { formatSlots } from '~/components/calendar-with-filters';
import { envConfigSelectors } from '~/selectors';
import { EditDateTime } from '~/routes';
import { withComponentDecisioner } from '~/hocs/with-component-decisioner';
import { EditDate } from '~/routes/edit';

const { formatTimeToPeriod } = formatSlots;

const componentDecisioner = [
  {
    supports: envConfigSelectors.selectIsNewCalendarEnabled,
    component: EditDateTime,
  },
];
export const config = {
  ReviewForm: {
    hideShopAddress: true,
    shopDetails: {
      title: 'Service provided by',
    },

    formatTimeSlot: startTime => formatTimeToPeriod(startTime),
  },
  editMode: {
    editDateComponent: withComponentDecisioner(() => componentDecisioner)(EditDate),
  },
};
